import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import { Button } from 'react-bootstrap';
import cx from 'classnames';

// Component
import ListGridCoverPhoto from '../../ListGridCoverPhoto';
import ImageSlider from '../ImageSlider';

// Redux Action
import { openImageLightBox, closeImageLightBox } from '../../../actions/ImageLightBox';
import { setStickyTop } from '../../../actions/Sticky/StrickyActions';

// Translation
import { FormattedMessage } from 'react-intl';

// Locale
import messages from '../../../locale/messages';

import ListDefaultPhoto from '../../ListDefaultPhoto';
import SocialShareModal from '../SocialShareModal';

import bt from '../../../components/commonStyle.css';
import s from './Photos.css';

const Photos = ({ data }) => {

  const dispatch = useDispatch();
  const currentIndex = useSelector(state => state.viewListing.currentIndex);
  const [sources, setSources] = useState([]);

  useEffect(() => {
    let sourceData = [], sourceObject = {}, coverPhoto, sticky, stickyHeight = 412;
    sticky = document.querySelector('[data-sticky-top]');

    if (data.listPhotos && data.listPhotos.length > 0) {
      coverPhoto = data.listPhotos[0].name;
      if (data.coverPhoto && data.coverPhoto) {
        data.listPhotos.map((item, key) => {
          if (item.id === data.coverPhoto) {
            sourceObject = {};
            sourceObject['src'] = '/images/upload/' + item.name;
            sourceData.push(sourceObject);
          }
        });

        data.listPhotos.map((item, key) => {
          if (item.id != data.coverPhoto) {
            sourceObject = {};
            sourceObject['src'] = '/images/upload/' + item.name;
            sourceData.push(sourceObject);
          }
        });
      } else {
        data.listPhotos.map((item, key) => {
          sourceObject = {};
          sourceObject['src'] = '/images/upload/' + item.name;
          sourceData.push(sourceObject);
        });
      }
      setSources(sourceData);
    }
    stickyHeight = (sticky.getBoundingClientRect().height + 10);
    dispatch(setStickyTop(stickyHeight));
  }, [data]);

  let coverPhoto, listPhotos;
  coverPhoto = data.coverPhoto;
  listPhotos = data.listPhotos;
  return (
    <div className={s.bannerContainer} data-sticky-top>
      <SocialShareModal
        listId={data.id}
        title={data.title}
        city={data.city}
        state={data.state}
        country={data.country}
      />
      <ImageSlider
        closeImageLightBox={dispatch(closeImageLightBox)}
        sources={sources}
        currentImage={currentIndex}
      />

      {
        listPhotos && listPhotos.length == 0 && <ListDefaultPhoto
          className={s.bannerImage}
          coverPhoto={coverPhoto}
          listPhotos={listPhotos}
          photoType={"xx_large"}
          bgImage
          openImageLightBox={dispatch(openImageLightBox)}
        >
        </ListDefaultPhoto>
      }
      <div className={s.positionRelative}>
        {
          sources && sources.length > 0 &&
          <ListGridCoverPhoto
            className={s.bannerImage}
            coverPhoto={coverPhoto}
            listPhotos={sources}
            photoType={"xx_large"}
            bgImage            >
          </ListGridCoverPhoto >
        }
        {
          sources && sources.length > 0 && <div className={cx(s.viewPhotosBtn, 'viewPhotosBtnRtl')}>
            <Button
              className={cx(bt.btnPrimary, s.viewPhotosBtn)}
              onClick={() => dispatch(openImageLightBox(1))}
            >
              <FormattedMessage {...messages.showAllPhotos} />
            </Button>
          </div>
        }
      </div>
    </div>
  );
}

Photos.propTypes = {
  listPhotos: PropTypes.array,
  coverPhoto: PropTypes.number,
  openImageLightBox: PropTypes.any.isRequired,
  closeImageLightBox: PropTypes.any.isRequired,
  imageLightBox: PropTypes.bool.isRequired,
  formatMessage: PropTypes.any,
};

Photos.defaultProps = {
  listPhotos: [],
  imageLightBox: false
}

export default withStyles(bt, s)(Photos);